import { commonConfigurations } from './environment.commonConfigurations';
import { EnvironmentSpecificServiceList, IEnvironment, IEnvironmentSpecificConfigurations } from './environment.model';

const initialNavigation: any = 'disabled';

const environmentSpecificServiceList = new EnvironmentSpecificServiceList('dev', true);
// environmentSpecificServiceList.PCXBusiness = "http://pcx.seliselocal.com:5000/PCXWebService/"
export const environmentSpecificConfigurations: IEnvironmentSpecificConfigurations = {
    IsAzStorage: true,
    BuildVersion: 'v2022.12.26.1',
    production: false,
    IsStaging: false,
    beeUid: 'dev',
    isSSo: false,
    isDevLocal: false,
    initialNavigation,
    action: `http://`,
    SubDomainName: `pcx.seliselocal.com`,
    DomainName: `seliselocal.com`,
    SessionKey: `set_from_acp.seliselocal.com`,
    landingUri: `http://pcx.seliselocal.com`,
    SiteId: 'CF55B6DF-585D-4AEF-8A71-43C11E8ACEA8',
    BuildPipelineId: 'baad454e-7566-43e7-a124-1aa290e770ad',
    MaintenanceManagerURL: `https://maintenancemanager.seliselocal.com/api/tenants`,
    JarowaWorkorderUrl: `https://www-appenzell-pool.enable.jarowa.ch/workOrderDetail/WORKORDER_ID/00000000-0000-0000-0000-000000000000`,
    WagePredictionService: `https://ipex-wage-prediction.stage.ipex.ch`,
    WagePredictionServiceUserName: `selise`,
    WagePredictionServicePassword: `ibexDerSteinbock#008`,
    caseCenterUri: 'http://upload-ipex.seliselocal.com',
    SlackWebHookUrl: 'https://hooks.slack.com/services/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',
    SlackAdminWebHookUrl: 'https://hooks.slack.com/services/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',
    ClaimCenterUri: "https://selise-repair-center.stage.ipex.ch",
    IpexFileService: 'https://ipex-file-service-jx-d.tech.ipex.ch',
    IpexDataBeastService: 'https://ipex-data-beast-jx-d.tech.ipex.ch',
    ClaimCenterLinkBaseUri: "https://selise-repair-center-jx-d.tech.ipex.ch",
    UILMUrl: 'https://api.seliseblocks.com/uilm/v1/Key/GetUilmFile',
    ProjectKey: '368F2327A9444A1798104730268C51DC',
    AutoClearingUserId: '8fb2b75b-38cb-4c50-869e-ca76a2e4a8b0'
};

export const environment: IEnvironment = {
    ...commonConfigurations,
    ...environmentSpecificConfigurations,
    ...environmentSpecificServiceList
};

export const environmentLocal = environment;
